import { Alert } from "@mui/material";

interface INoCardFoundProps {
  componentName: string;
}

export function NoCardFound(props: INoCardFoundProps): JSX.Element {
  const { componentName } = props;
  return (
    <Alert severity="error" variant="filled" sx={{ minWidth: "250px", width: "100%", whiteSpace: "no-wrap" }}>
      {componentName} not found!
    </Alert>
  );
}
